var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/auth_layout/index.tsx";
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Link, Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import LandingGradient from 'soapbox/components/landing-gradient';
import SiteLogo from 'soapbox/components/site-logo';
import { useAppSelector, useFeatures, useSoapboxConfig, useOwnAccount } from 'soapbox/hooks';
import { Button, Card, CardBody } from '../../components/ui';
import LoginPage from '../auth_login/components/login_page';
import PasswordReset from '../auth_login/components/password_reset';
import PasswordResetConfirm from '../auth_login/components/password_reset_confirm';
import RegistrationForm from '../auth_login/components/registration_form';
import ExternalLoginForm from '../external_login/components/external-login-form';
import Footer from '../public_layout/components/footer';
import RegisterInvite from '../register_invite';
import Verification from '../verification';
import EmailPassthru from '../verification/email_passthru';
const messages = defineMessages({
  register: {
    "id": "auth_layout.register",
    "defaultMessage": "Create an account"
  }
});
const AuthLayout = () => {
  const intl = useIntl();
  const history = useHistory();
  const {
    search
  } = useLocation();
  const account = useOwnAccount();
  const siteTitle = useAppSelector(state => state.instance.title);
  const soapboxConfig = useSoapboxConfig();
  const pepeEnabled = soapboxConfig.getIn(['extensions', 'pepe', 'enabled']) === true;
  const features = useFeatures();
  const instance = useAppSelector(state => state.instance);
  const isOpen = features.accountCreation && instance.registrations;
  const pepeOpen = useAppSelector(state => state.verification.instance.get('registrations') === true);
  const isLoginPage = history.location.pathname === '/login';
  const shouldShowRegisterLink = isLoginPage && (isOpen || pepeEnabled && pepeOpen);
  return /*#__PURE__*/React.createElement("div", {
    className: "h-full",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(LandingGradient, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("main", {
    className: "relative h-full sm:flex sm:justify-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full h-full flex flex-col sm:max-w-lg md:max-w-2xl lg:max-w-6xl",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("header", {
    className: "flex justify-between relative py-12 px-2 mb-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative z-0 flex-1 px-2 lg:flex lg:items-center lg:justify-center lg:absolute lg:inset-0",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/",
    className: "cursor-pointer",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(SiteLogo, {
    alt: siteTitle,
    className: "h-7",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 17
    }
  }))), shouldShowRegisterLink && /*#__PURE__*/React.createElement("div", {
    className: "relative z-10 ml-auto flex items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "link",
    icon: require('@tabler/icons/user.svg'),
    to: "/signup",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 17
    }
  }, intl.formatMessage(messages.register)))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col justify-center items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "pb-10 sm:mx-auto w-full sm:max-w-lg md:max-w-2xl",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "rounded",
    size: "xl",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(CardBody, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Switch, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 19
    }
  }, account && /*#__PURE__*/React.createElement(Redirect, {
    from: "/login",
    to: "/",
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 33
    }
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/verify",
    component: Verification,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 21
    }
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/verify/email/:token",
    component: EmailPassthru,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 21
    }
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/login/external",
    component: ExternalLoginForm,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 21
    }
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/login/add",
    component: LoginPage,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 21
    }
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/login",
    component: LoginPage,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 21
    }
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/signup",
    component: RegistrationForm,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 21
    }
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/reset-password",
    component: PasswordReset,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 21
    }
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/edit-password",
    component: PasswordResetConfirm,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 21
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/invite/:token",
    component: RegisterInvite,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 21
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/auth/password/new",
    to: "/reset-password",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 21
    }
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/auth/password/edit",
    to: `/edit-password${search}`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 21
    }
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "mt-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Footer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 13
    }
  })))));
};
export default AuthLayout;